<template>
	<div>
		<section class="content-header mt-2">
			<h1 class="pull-left"><font-awesome-icon icon="terminal" /> Queries</h1>
			<b-button class="btn btn-success pull-right" @click="create"><font-awesome-icon icon="plus" /></b-button>
		</section>
		<div class="content">
			<error-component
				v-if="exceptions.length > 0"
				v-bind="exceptions[0]">
			</error-component>
			<success-component
				v-if="success.length > 0"
				:message="success">
			</success-component>
			<div v-if="loading">
				<bouncing-component></bouncing-component>
			</div>
			<div v-else>
				<render-index-table v-if="pagination.totalRows > 0" :queries="queries" />

				<div class="empty query" v-else>
					<p>
						You don't have any query yet.
					</p>
					<div>
						<b-button class="btn btn-success" @click="create">Write your first query</b-button>
					</div>
				</div>

				<b-pagination align="center" size="md"
							:total-rows="pagination.totalRows"
							v-model="pagination.currentPage"
							:limit="pagination.limit"
							:per-page="pagination.limit"
							@change="change">
				</b-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import RenderIndexTable from './RenderIndexTable.vue';
	import BouncingComponent from '../../components/Bouncing-loader.vue';
	import SuccessComponent from '../../components/Success.vue';
	import ErrorComponent from '../../components/ErrorView.vue';
	import {mapState} from 'vuex';

	export default {
		data() {
			return {
				unwatch: '',
				loading: true,
			}
		},
		components: {
			SuccessComponent,
			ErrorComponent,
			BouncingComponent,
			RenderIndexTable
		},
		computed: {
			...mapState('queries', {
				queries: 'items',
				pagination: 'pagination'
			}),
			...mapState({
				organizationId: 'organizationSelected',
				success: 'success',
				exceptions: 'exceptions'
			})
		},
		beforeDestroy() {
			this.$store.commit('queries/SET_QUERIES', []);
			this.$store.commit('queries/SET_PAGINATION', { current_page: 1, total: 0 });
			this.$store.dispatch('clearMessages');
			this.unwatch();
		},
		created() {
			let page = this.$route.query.page;
			if (page) {
				this.update(parseInt(page));
			}
			else {
				this.$store.dispatch('queries/fetch').then(() => {
					this.loading = false;
				});
			}
			this.unwatch = this.$store.watch(
				(state)=>
					this.$store.state.organizationSelected
				,
				(newValue, oldValue)=>{
					this.$store.commit('queries/SET_PAGINATION', { current_page: 1, total: 0 });
					this.$store.dispatch('clearMessages');
					this.loading = true;
					this.$store.dispatch('queries/fetch').then(() => {
						this.loading = false;
					});
					this.$router.push({ name: 'query', query: { page: 1 } });
				},
			);
		},
		methods: {
			update(page) {
				this.$store.commit('queries/SET_CURRENT_PAGE', page);
				this.loading = true;
				this.$store.dispatch('queries/fetch').then(() => {
					this.loading = false;
				});
			},
			change(page) {
				this.update(page);
				this.$router.push({ name: 'query', query: { page: page } });
			},
			create() {
				this.$router.push({name: 'query.create'});
			},
		},
	}
</script>